export const SETPRJLIST = "SETPRJLIST";
export const SETACTIVITYLIST = "SETACTIVITYLIST";
export const SETTIMESHEETLIST = "SETTIMESHEETLIST";
export const SETTIMESAVE = "SETTIMESAVE";
export const SETMONTHLIST = "SETMONTHLIST";
export const SETEXPORTLIST="SETEXPORTLIST";
export const SETEXPORTFILE="SETEXPORTFILE";